import type { TranslationSourceDatasetResponse } from '../../api/transcriptionFrench.api';

export function createShuffleSession(seed: string = crypto.randomUUID()) {
  return { seed, cursors: new Map<number, number>([[1, 0]]), source: '' };
}

/**
 * Records where the shuffled order continues, and says whether anything is left.
 *
 * The server owns the order and hands back the next cursor, so page numbers play
 * no part: a page count computed over a shrinking dataset would promise pages
 * that no longer exist.
 */
export function rememberShufflePage(
  session: ReturnType<typeof createShuffleSession>,
  page: number,
  response: TranslationSourceDatasetResponse,
): boolean {
  if (response.shuffleSeed) session.seed = response.shuffleSeed;
  if (response.datasetSource) session.source = response.datasetSource;
  if (typeof response.nextCursor === 'number') {
    session.cursors.set(page + 1, response.nextCursor);
    return true;
  }
  return false;
}
